import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { getPath, PathUnit } from './consts/path.const';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'role-validator',
        pathMatch: 'full',
      },
      {
        path: 'role-validator',
        loadComponent: () => import('./pages/role-validator/role-validator.component').then(m => m.RoleValidatorComponent),
      },
      {
        path: getPath(PathUnit.LandingPage),
        redirectTo: 'role-validator',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'role-validator',
  },
];
